/**
 * Entscheidungskern des Oberflächen-Umschalters (#741).
 *
 * Reine Funktionen, bewusst ohne Angular und ohne DOM-Zugriff. Damit ist der Kern
 * ohne Browser-Attrappe testbar, und der Angular-Teil darüber bleibt eine dünne
 * Schale.
 */

/** Die beiden Kanäle, zwischen denen der Umschalter wechselt. */
export type UiChannel = 'stable' | 'next';

/**
 * Cookie-Werte, die ingress-nginx für `canary-by-cookie` versteht.
 *
 * Die Annotation kennt ausschliesslich diese beiden Zeichenketten. Jeder andere
 * Wert — und ein fehlendes Cookie — fällt auf das Canary-Gewicht zurück, das
 * ohne `canary-weight` gleich 0 ist. „Standard 4.x" folgt damit aus der
 * Konstruktion und ist keine Einstellung, die jemand pflegen muss.
 */
const COOKIE_VALUE: Record<UiChannel, string> = {
  next: 'always',
  stable: 'never',
};

/** Ein Jahr in Sekunden — die Wahl soll Sitzung und Browser-Neustart überleben. */
export const CHANNEL_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export function toCookieValue(channel: UiChannel): string {
  return COOKIE_VALUE[channel];
}

/** Der jeweils andere Kanal. */
export function otherChannel(channel: UiChannel): UiChannel {
  return channel === 'next' ? 'stable' : 'next';
}

/**
 * Baut den vollständigen Wert für eine `document.cookie`-Zuweisung.
 *
 * Kein `Domain`-Attribut: beide Versionen liegen auf demselben Host, host-eigen
 * ist damit richtig und die engste mögliche Zusage.
 */
export function buildCookie(cookieName: string, channel: UiChannel): string {
  return [
    `${cookieName}=${toCookieValue(channel)}`,
    'Path=/',
    `Max-Age=${CHANNEL_COOKIE_MAX_AGE}`,
    'SameSite=Lax',
    'Secure',
  ].join('; ');
}
